// import _ from 'lodash-es';
import { createTheme } from '@mui/material/styles';
import { useSelector } from 'src/store/Store';
import { AppState } from '../store/Store';
import components from './Components';
import typography from './Typography';
import { shadows, darkshadows } from './Shadows';
import { DarkThemeColors } from './DarkThemeColors';
import { LightThemeColors } from './LightThemeColors';
import { baseDarkTheme, baselightTheme } from './DefaultColors';
import * as locales from '@mui/material/locale';


export const BuildTheme = (config: any = {}) => {
  const themeOptions: any = LightThemeColors.find((theme) => theme.name === config.theme);
  const darkthemeOptions: any = DarkThemeColors.find((theme) => theme.name === config.theme);
  const customizer: any = useSelector((state: AppState) => state.customizer);
  const defaultTheme: any = customizer.activeMode === 'dark' ? baseDarkTheme : baselightTheme;
  const defaultShadow: any = customizer.activeMode === 'dark' ? darkshadows : shadows;
  const themeSelect: any = customizer.activeMode === 'dark' ? darkthemeOptions : themeOptions;
  const baseMode: any = {
    palette: {
      mode: customizer.activeMode,
    },
    shape: {
      borderRadius: customizer.borderRadius,
    },
    shadows: defaultShadow,
    typography: typography,
  };
  const theme: any = createTheme(
    // _.merge({}, baseMode, defaultTheme, locales, themeSelect, {
    //   direction: config.direction,
    // }),
    deepMerge({}, baseMode, defaultTheme, locales, themeSelect, {
      direction: config.direction,
    })
  );
  
  // Create a new theme with components included
  const themeWithComponents = createTheme({
    ...theme,
    components: components(theme),
  });

  return themeWithComponents;
};

const ThemeSettings = () => {
  const activeTheme = useSelector((state: AppState) => state.customizer.activeTheme);
  const theme = BuildTheme({
    direction: document.dir,
    theme: activeTheme,
  });
  return theme;
};

export { ThemeSettings };

function deepMerge(target: any, ...sources: any[]): any {
  if (!sources.length) return target;

  const source = sources.shift();
  const result = { ...target }; // Create a new object instead of mutating

  if (typeof target === 'object' && typeof source === 'object') {
    for (const key in source) {
      if (
        source[key] &&
        typeof source[key] === 'object' &&
        !Array.isArray(source[key])
      ) {
        result[key] = deepMerge(result[key] || {}, source[key]);
      } else {
        result[key] = source[key];
      }
    }
  }

  return deepMerge(result, ...sources);
}